const API_URL = "https://preview.insightwin.com/backend";

export default API_URL;
